// @ts-strict-ignore
import React from 'react'
import { IonList, IonItem, IonLabel, IonGrid, IonRow } from '@ionic/react'
import classnames from 'classnames'
import { SectionListGroupContainer as Container } from 'mytours-read-common'

import { formatCurrency, getDirMode } from '../../../platform'

import '../styles/sectionGroup.less'

interface Props {
	type: 'price' | 'opening_hours'
}

class SectionListGroup extends React.PureComponent<Container.Props & Container.Actions & Props> {
	renderHeader = () => {
		const {
			section: { title },
		} = this.props

		return (
			<IonRow className="block-header" dir={getDirMode()}>
				<h2 className="subheading" data-cy="story-screen-section-heading">
					{title}
				</h2>
			</IonRow>
		)
	}

	renderList = () => {
		const {
			section: { section_items: sectionItems },
			type,
		} = this.props

		return (
			<IonList
				className={classnames('section-group-list block-content', getDirMode())}
				lines="full"
				data-cy="story-screen-section-content"
			>
				{sectionItems.map((item: any) => {
					if (item.exception_row) {
						return (
							<IonItem key={item.id}>
								<IonLabel className="text-label">{item.description}</IonLabel>
							</IonItem>
						)
					} else {
						let note
						switch (type) {
							case 'price':
								note = item.price_currency && formatCurrency(item.price_currency, item.price_cents)
								break
							case 'opening_hours':
								note = item.time
								break
							default:
								break
						}

						return (
							<IonItem key={item.id} dir={getDirMode()}>
								<IonRow className="item-row">
									<IonLabel className="text-label">{item.description}</IonLabel>
									{note && <IonLabel className="text-label note">{note}</IonLabel>}
								</IonRow>
							</IonItem>
						)
					}
				})}
			</IonList>
		)
	}

	render() {
		return (
			<IonGrid className="section-group list-layout">
				{this.renderHeader()}
				{this.renderList()}
			</IonGrid>
		)
	}
}

const SectionListGroupComponent = Container.default(SectionListGroup)
export default SectionListGroupComponent
